import { getPageInfo } from './index.js';

export const errorPageAnalytics = async ({ location, appState, code, message }) => {
    return {
        event: 'trackPage',
        page: getPage({ location, appState, code, message }),
    };
};

export const getPage = ({ location, appState, code, message }) => {
    const { language, country, prevPath, region, currencyCode } = appState;
    const pageName = `error - ${code} - ${message}`;

    return {
        pageInfo: getPageInfo({ location, language, country, deviceType: 'website', pageName, prevUrl: prevPath }),
        category: {
            pageType: 'error page',
            primaryCategory: 'error page',
            subCategory1: 'error page',
            subCategory2: code || '',
            subCategory3: message || '',
            subCategory4: message || '',
        },
        attributes: {
            region,
            currency: currencyCode,
            errorDetails: message || '',
        },
    };
};
